import { request } from '../utils/request';

export const getConversationsAPI = data =>
  request.post('/support/admin/get-conversations', data);

export const getConversationDetailsAPI = data =>
  request.get('/support/admin/get-conversation-details', { params: data });

export const getAllTagsForSupportChatAPI = () =>
  request.get('/support/admin/get-all-tags');

export const flagConversationAPI = ({ sessionAddress, flagged }) =>
  request.post('/support/admin/flag-conversation', {
    sessionAddress,
    flagged,
  });

export const getConversationSnapshotAPI = data =>
  request.post('/support/admin/get-conversations-snapshot', data);

export const downloadSupportChatCSVAPI = data =>
  request.post('/support/admin/download-support-chat-csv', data);
